/**
 * Shared utility functions for Companies page components
 */

// Quality name mapping from Excel file names to display names
export const mapQualityName = (name) => {
  if (!name) return 'Unknown';
  const QUALITY_MAP = {
    'NStock-Low': 'LOW',
    'NStock- V Low': 'V LOW',
    'NStock- VV LOW': 'VV LOW',
    'NStock-Moderate': 'MODERATE',
    'NStock-High': 'HIGH',
    'NStock-New': 'NEW',
    'NStock-V Low': 'V LOW',
    'NStock-VV Low': 'VV LOW',
  };
  if (QUALITY_MAP[name]) return QUALITY_MAP[name];
  const lowerName = name.toLowerCase();
  if (lowerName.includes('vv low')) return 'VV LOW';
  if (lowerName.includes('v low')) return 'V LOW';
  if (lowerName.includes('low')) return 'LOW';
  if (lowerName.includes('moderate')) return 'MODERATE';
  if (lowerName.includes('high')) return 'HIGH';
  if (lowerName.includes('new')) return 'NEW';
  return name;
};

// Get quality tag color classes
export const getQualityColor = (tag) => {
  const mappedTag = mapQualityName(tag);
  const colors = {
    'NEW': 'bg-blue-100 text-blue-800',
    'HIGH': 'bg-green-100 text-green-800',
    'MODERATE': 'bg-yellow-100 text-yellow-800',
    'LOW': 'bg-orange-100 text-orange-800',
    'V LOW': 'bg-red-100 text-red-800',
    'VV LOW': 'bg-red-200 text-red-900',
  };
  return colors[mappedTag] || 'bg-gray-100 text-gray-800';
};

// Format currency value with Indian notation
export const formatValue = (value) => {
  if (value >= 10000000) return `₹${(value / 10000000).toFixed(2)} Cr`;
  if (value >= 100000) return `₹${(value / 100000).toFixed(2)} L`;
  return `₹${value.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
};

// Get tab display name
export const getTabDisplayName = (tab) => {
  switch (tab) {
    case 'stocks': return 'Stocks';
    case 'mutualfunds': return 'Mutual Funds';
    case 'pledge': return 'Pledge Status';
    case 'merged': return 'Merged Stocks';
    case 'private': return 'Private Stocks';
    case 'unlisted': return 'Unlisted Stocks';
    default: return 'Data';
  }
};
